import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { ProductCardDetails } from '../../types/product-card-details.interface';

@Component({
	selector: 'app-product-card',
	templateUrl: './product-card.component.html',
	styleUrls: ['./product-card.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class ProductCardComponent {
	@Input() product: ProductCardDetails;

	@Output() selected = new EventEmitter();

	@Output() details = new EventEmitter();

	constructor() { }

	get headerCss() {
		if (!this.product.headerImage) return '';
		return `background-image: url(${this.product.headerImage})`;
	}

	select(e) {
		this.selected.emit(e);
	}

	showDetails() {
		this.details.emit(this.product.id);
	}
}
